// Platform defaults; wl-customer constants/sourcingFees.ts is the source and stores
// both figures including UK VAT.
export const DEFAULT_SOURCING_FEE_PERCENTAGE = 2.4
export const DEFAULT_SOURCING_FEE_MINIMUM = 3600
export const UK_VAT_RATE = 0.2
